import React, { ReactNode } from 'react';
import {
	Page,
	PageTitle,
	PageSubtitle,
	ReviewCard,
	Title,
	CardData,
	PersonCard,
	PersonCardData,
	PersonCardAvatar,
	PersonFio,
	PersonText,
} from './ExpertOpinionStyled';
import data, { IExpertOpinion } from './data';

const PersonItem = ({ avatar, fio, text }: { avatar: ReactNode; fio: string; text?: ReactNode }) => (
	<PersonCard>
		<PersonCardAvatar>{avatar}</PersonCardAvatar>
		<PersonCardData>
			<PersonFio>{fio}</PersonFio>
			<PersonText>{text}</PersonText>
		</PersonCardData>
	</PersonCard>
);

const OpinionItem = ({ title, picture, experts, text }: IExpertOpinion) => (
	<ReviewCard>
		{picture}
		<CardData>
			<Title>{title}</Title>
			{experts?.map((el, i) => (
				<PersonItem key={i} {...el} />
			))}
			{text}
		</CardData>
	</ReviewCard>
);
const ExpertOpinions = () => {
	return (
		<Page>
			<PageTitle>Заключения экспертов</PageTitle>
			<PageSubtitle>
				Мнения экспертов, представляющих ведущие образовательные и<br /> научные учреждения, о платформе Учи.ру
			</PageSubtitle>
			{data.map((el, i) => (
				<OpinionItem key={i} {...el} />
			))}
		</Page>
	);
};

export default ExpertOpinions;
